<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mind-mapping`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.852 7.812A5 5 0 107 15.585V36.25l.003.239C7.088 39.424 8.725 42 11.286 42H15a1 1 0 001-1v-2a1 1 0 00-1-1h-3.525l-.03-.038-.068-.101-.072-.132c-.186-.37-.305-.897-.305-1.479V27h4a1 1 0 001-1v-2a1 1 0 00-1-1h-4v-7.416A5.001 5.001 0 0013 8l-.148-.188zM44 39a1 1 0 00-1-1H22a1 1 0 00-1 1v2a1 1 0 001 1h21a1 1 0 001-1v-2zm-1-16a1 1 0 011 1v2a1 1 0 01-1 1H22a1 1 0 01-1-1v-2a1 1 0 011-1h21zm1-13a1 1 0 00-1-1H22a1 1 0 00-1 1v2a1 1 0 001 1h21a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconMindMapping',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
